import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

// Reusable inner-page hero banner
export default function PageHero({ image, eyebrow, title, subtitle }) {
  return (
    <section className="relative pt-40 pb-24 md:pt-48 md:pb-32 overflow-hidden">
      <div className="absolute inset-0">
        <img src={image} alt={title} className="w-full h-full object-cover" />
        <div className="absolute inset-0" style={{ background: "linear-gradient(90deg, rgba(22,38,92,0.92) 0%, rgba(22,38,92,0.7) 60%, rgba(22,38,92,0.4) 100%)" }} />
      </div>
      <div className="relative max-w-[1400px] mx-auto px-5 md:px-8">
        {eyebrow && (
          <p className="text-white/70 uppercase tracking-[0.3em] text-xs font-semibold mb-4 oe-reveal">{eyebrow}</p>
        )}
        <h1 className="oe-heading text-white text-4xl md:text-6xl max-w-3xl oe-reveal">{title}</h1>
        {subtitle && (
          <p className="text-white/80 text-lg max-w-2xl mt-6 leading-relaxed oe-reveal">{subtitle}</p>
        )}
      </div>
    </section>
  );
}

export function CTAButton({ to, label, dark = false }) {
  return (
    <Link
      to={to}
      className={`group inline-flex items-center gap-3 font-semibold px-8 py-4 rounded-md transition-colors ${
        dark ? "oe-navy text-white hover:oe-navy-2" : "bg-oe-red text-white hover:opacity-90"
      }`}
    >
      <span className="w-8 h-8 rounded-full border border-white/50 flex items-center justify-center">
        <ArrowRight size={16} className="group-hover:translate-x-0.5 transition-transform" />
      </span>
      {label}
    </Link>
  );
}
